import LocalStorageService from '../../services/LocalStorageService'
import { locales } from '../../constants/languages'
import { innerI18n, i18n } from '../../main'

export default {
  state: {
    notificationsDrawer: { show: false },
    usedContentDrawer: { show: false, props: {} },
    contactModal: { show: false },
    successModal: {
      show: false,
      props: {}
    },
    termsAndConditionsModal: {
      show: false,
      props: {}
    },
    addResourceModal: {
      show: false,
      props: {}
    },
    shareResourceModal: { show: false, props: {} },
    shareContentModal: { show: false, props: {} },
    folderDeleteModal: { show: false, props: {} },
    folderCreateModal: { show: false },
    folderShareModal: { show: false, props: {} },
    folderManagePermissionsModal: { show: false, props: {} },
    forgotPasswordModal: { show: false, props: {} },
    askForInformationModal: { show: false },
    thanksModal: { show: false },
    userMenu: { show: false },
    fullPageLoader: { show: false },
    locale: LocalStorageService.getLang() || locales.spanish,
    localeMenu: { show: false },
    sidebarMenu: { show: false },
    feedbackModal: { show: false },
    doneModal: {
      show: false,
      props: {}
    },
    removeResourceModal: {
      show: false,
      props: null
    },
    trialInviteModal: { show: false },
    discardChangesModal: {
      show: false,
      props: {
        confirmFunc: null,
        funcProps: null
      }
    },
    addKreaResourceLanguageModal: { show: false, props: {} },
    deleteKreaClassModal: { show: false, props: {} },
    choiceModal: { show: false, props: {} },
    freemiumConfirmationModal: { show: false, confirmFunc: null },
    redirectPath: null,
    activeAccountModal: { show: false },
    sentInvitationsModal: { show: false },
    onboardingModal: { show: false },
    foundationContactModal: { show: false },
    viewCatalogueModal: { show: false },
    onboarding: { show: false },
    advancedFilters: { show: false },
    shareKimpleFolderModal: { show: false, props: {} },
    activateTutorialModal: { show: false, props: {} },
    inviteUsersModal: { show: false, props: {} },
    kreaFileUploaderModal: { show: false, props: {} },
    kreaPublishContentModal: { show: false, props: {} },
    kreaUnpublishContentModal: { show: false, props: {} },
    kreaEditKeywordsContentModal: { show: false, props: {} },
    kreaDeleteModal: { show: false, props: {} },
    deleteMembersModal: { show: false, props: {} },
    orderResourcesModal: { show: false, props: {} },
    createSharingGroupModal: { show: false, props: {} },
    editSharingGroupModal: { show: false, props: {} },
    addSharingGroupMembersModal: { show: false, props: {} },
    kreaContentImageModal: { show: false, props: {} },
    notificationModal: { show: false, props: {} },
    isModalOpen: false,
    cropImageModal: { show: false, props: {} },
    registerUseModal: { show: false, props: {} },
    suggestTopicModal: { show: false, props: {} },
    innerLocale: LocalStorageService.getInnerLang() || locales.spanish,
    kreaCreateInTeamModal: { show: false, props: {} }
  },

  mutations: {
    show(state, elementWithProps) {
      state[elementWithProps.element].show = true
      state[elementWithProps.element].props = elementWithProps.props
      if (elementWithProps.element !== 'fullPageLoader') state.isModalOpen = true
    },
    hide(state, elementWithProps) {
      state[elementWithProps.element].show = false
      if (elementWithProps.element !== 'fullPageLoader') state.isModalOpen = false
    },
    toLocale(state, locale) {
      state.locale = locale
    },
    setRedirectPath(state, newPath) {
      state.redirectPath = newPath
    },
    setInnerLocale(state, locale) {
      state.innerLocale = locale
    }
  },

  actions: {
    setRedirectPath({ commit }, path) {
      commit('setRedirectPath', path)
    },
    showElement({ commit }, elementWithProps) {
      commit('show', elementWithProps)
    },
    hideElement({ commit }, elementWithProps) {
      commit('hide', elementWithProps)
    },
    changeLocale({ commit }, locale) {
      commit('toLocale', locale)
      LocalStorageService.setLang(locale)
      i18n.locale = locale
      commit('hide', { element: 'localeMenu' })
    },
    changeInnerLocale({ commit }, locale) {
      commit('setInnerLocale', locale)
      innerI18n.locale = locale
      LocalStorageService.setInnerLang(locale)
    }
  }
}
